import styles from "./ErrorMessage.module.css";
import { AttentionIcon } from "../../assets/icons/AttentionIcon";
import type { JSX } from "react";

interface ErrorMessageProps {
  message: string;
  messageReferenceId: string;
}
const ErrorMessage = (props: ErrorMessageProps): JSX.Element => {
  return (
    <div className={styles.errorMessage} data-testid="errorMessage">
      <div className={styles.icon}>
        <AttentionIcon data-testid="errorIcon" height={22} width={22} />
      </div>
      <span id={props.messageReferenceId} role="alert">
        {props.message}
      </span>
    </div>
  );
};

export { ErrorMessage };
